import { render, staticRenderFns } from "./LifeEventsTable.vue?vue&type=template&id=97b67bba&scoped=true&"
import script from "./LifeEventsTable.vue?vue&type=script&lang=js&"
export * from "./LifeEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./LifeEventsTable.vue?vue&type=style&index=0&id=97b67bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b67bba",
  null
  
)

export default component.exports